// extracted by mini-css-extract-plugin
module.exports = {"dataTable":"_1sCTA-","nx-data-table--large":"_351lg-","nxDataTableLarge":"_351lg-"};